module.exports = __webpack_public_path__ + "static/media/builder_form_label_dropdown.9c2d8810.png";